import { get } from 'lodash';
 
const policySourceSystem = (policies) => {
    // Map SourceSystemCode with SourceSystemName
    var sourceSystemName = "";
    var sourceSystemCode = get(policies, '[0].sourceSystemCode', '');
    if(sourceSystemCode !== undefined && sourceSystemCode.length > 0){
        if(sourceSystemCode.toUpperCase() === "PAS" || sourceSystemCode.toUpperCase() === "LEO" )
        {
            sourceSystemName = "TAL"
        }
        else if (sourceSystemCode.toUpperCase() === "LFH" ){
            sourceSystemName = "ASTERON"
        }
        else if (sourceSystemCode.toUpperCase() === "CLO" ){
            sourceSystemName = "PPlans"
        }
    } 
    return sourceSystemName; 
}

export default policySourceSystem;